import { render, staticRenderFns } from "./EstimateHeader.vue?vue&type=template&id=4e817294&scoped=true&"
import script from "./EstimateHeader.vue?vue&type=script&lang=ts&"
export * from "./EstimateHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EstimateHeader.vue?vue&type=style&index=0&id=4e817294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e817294",
  null
  
)

export default component.exports